import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// adjust the paths if your locales folder is elsewhere
import en from "./locales/en.json";
import fr from "./locales/fr.json";

// Default to EN; switch to FR if URL starts with /fr
const urlLang =
  typeof window !== "undefined" && window.location.pathname.startsWith("/fr")
    ? "fr"
    : "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: urlLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
